// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__1q1W-","Input":"Input_Input__S6JQM","Small":"Input_Small__1qjkG","goUp":"Input_goUp__1eb5E"};